// extracted by mini-css-extract-plugin
export default {"button":"Contract_button__f8GEy","divider":"Contract_divider__nWP0r","link":"Contract_link__XuybA","buttonsWrapper":"Contract_buttonsWrapper__B6odc"};